<template>
    <div class="input-group input-group-lg border" :class="{'shadow' : (focused || results.length)}">
        <div class="input-group-prepend d-none d-sm-flex">
            <button class="border-0 px-3">
                <img src="../assets/images/home_button.svg" alt="">
            </button>
        </div>
        <input type="text" v-model.trim="term" class="form-control" :class="{'is-invalid' : errors.length }" placeholder="Enter your Post Code"
               @focus="onFocus" @blur="onBlur" @keypress.enter="findAddress">
            <div class="invalid-tooltip" v-for="(error, key) in errors" :key="key">
                {{error}}
            </div>
        <div class="input-group-append">
            <button class="btn btn-success btn-success-gradient" @click="findAddress" :disabled="running">
                GET STARTED
            </button>
        </div>
    <collapse-transition>
        <div class="results" v-if="results.length">
            <ul>
                <li v-for="(result, index) in results" :key="index">
                    <div class="suggestion-item pl-4 py-4 text-dark" @click="addressSelected(index)">{{result.address}}</div>
                </li>
            </ul>
            <div class=" py-2 text-center" v-if="1 === 2">
                <a href="#" class="btn btn-link">Can’t see your address? Enter it manually.</a>
            </div>
        </div>
    </collapse-transition>
    </div>
</template>

<script>
import api from "../utils/api";

import {each} from 'lodash'
// const _  = require('../utils/lodash').default;
import {CollapseTransition} from 'vue2-transitions';

export default {
    name: "AddressLocator",
    components: {CollapseTransition},
    data: function () {
        return {
            term: '',
            focused: false,
            running: false,
            errors: [],
            results: [],
        }
    },
    methods: {
        onFocus: function () {
            this.focused = true;
        },
        onBlur: function () {
            this.focused = false;
        },
        findAddress: function () {
            if (this.running) {
                return
            }
            this.running = true
            this.errors = [];
            this.results = [];
            
            if (this.term === '') {
                this.errors.push('Please enter your post code');
                return;
            }
            
            let that = this;
            api.address(this.term).then(response => {
                if (!response.data.data.length) {
                    this.errors.push('No results were found');
                } else {
                    each(response.data.data, (value) => {
                        that.results.push(value);
                    })
                }
            }).finally(() => {
                that.running = false
            })
        },
        addressSelected: function (index) {
            let address = this.results[index];
            this.results = [];
            this.$emit('selected', address)
        },
        getLocation: function () {
            this.errors = [];
            let that = this;
            if (navigator.geolocation) {
                // timeout at 60000 milliseconds (60 seconds)
                var options = {timeout: 60000};
                navigator.geolocation.getCurrentPosition(
                    function (position) {
                        console.log(position);
                    },
                    function (error) {
                        switch (error.code) {
                            case 1:
                                that.errors.push("Sorry, permissions for getting your location are denied.");
                                break;
                            case 2:
                                that.errors.push("Sorry, your position is unavailable a the moment.");
                                break;
                            case 3:
                                that.errors.push("Sorry, we couldn't determine your location in timely manner.");
                                break;
                        }
                    },
                    options
                );
            } else {
                this.errors.push("Sorry, browser does not support geolocation!");
            }
        }
    },
}
</script>

<style scoped lang="scss">
    @import "../sass/base";

    .input-group {
        padding: 0.4rem;
        background-color: $white;
        border-radius: $border-radius;
        transition: box-shadow 0.3s ease-out;

        &.shadow {
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.5) !important;
        }

        .input-group-prepend {
            border-right: 1px solid $border-color;

            button {
                background-color: transparent;

            }
        }

        .form-control {
            border: none;
            font-size: 1rem;
            line-height: 1rem;
            padding: 1rem;
            background: transparent;
            height: 100%;

            &:focus {
                outline: none;
                box-shadow: none;
            }
        }

        .input-group-append {
            button {
                border-radius: $border-radius !important;
                font-size: 1rem;
                padding: 0.5rem 2.8rem;
                @include media-breakpoint-down(sm) {
                    padding: 0.5rem 0.8rem;
                }
            }
        }
    }

    .results {

        overflow: hidden;
        position: absolute;
        background-color: $white;
        left: -1px;
        right: -1px;
        top: 4rem;
        border: $border-width solid $border-color;
        border-bottom-left-radius: $border-radius;
        border-bottom-right-radius: $border-radius;
        z-index: 100;
        box-shadow: 0 15px 20px rgba(0, 0, 0, 0.5);

        ul {
            padding: 0;
            margin: 0;
            max-height: 45vh;
            overflow: auto;
            .suggestion-item {
                cursor: pointer;

                &:hover {
                    background-color: $gray-200;
                }
            }
        }


    }
</style>
